import type { CalculateData } from '@/app/cc/_types/types';
import { createFetch } from '@/lib/cc/commonFetch';

const BJD_CD = '1165000000';

export default async function calculateUsage(price: number, type: 'rent' | 'sale') {
  const fetch = createFetch('int');
  const data = await fetch<CalculateData>(`/new-bill/safe-care/payment/price`, {
    method: 'GET',
    params: {
      type: type === 'rent' ? 'L' : 'S',
      price,
      legalDongCode: BJD_CD,
    },
  });
  return data.data;
}
